import { render, staticRenderFns } from "./AccountantInvoiceTable.vue?vue&type=template&id=99a613c8&scoped=true&"
import script from "./AccountantInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./AccountantInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountantInvoiceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a613c8",
  null
  
)

export default component.exports